import { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

// ServiceCatalogFieldsCard: component overview only (legacy overviewContent)
export const serviceCatalogFieldsCard: ExtensionDefinition =
  EntityCardBlueprint.make({
    name: 'service-catalog-fields',
    params: {
      type: 'content',
      filter: { kind: 'component' },
      loader: () =>
        import('../../components/catalog/ServiceCatalogFieldsCard').then(m => (
          <m.ServiceCatalogFieldsCard />
        )),
    },
  });

// CustomIncidentIOCard: components + groups (legacy overviewContent + groupPage)
export const incidentIoCard: ExtensionDefinition = EntityCardBlueprint.make({
  name: 'incident-io',
  params: {
    type: 'content',
    filter: { $any: [{ kind: 'component' }, { kind: 'group' }] },
    loader: () =>
      import('../../components/incidentio').then(m => (
        <m.CustomIncidentIOCard />
      )),
  },
});

// TeamManagerCard: groups only (legacy groupPage overview)
export const teamManagerCard: ExtensionDefinition = EntityCardBlueprint.make({
  name: 'team-manager',
  params: {
    type: 'content',
    filter: { kind: 'group' },
    loader: () =>
      import('../../components/catalog/TeamManagerCard').then(m => (
        <m.TeamManagerCard />
      )),
  },
});

export const entityCards: ExtensionDefinition[] = [
  serviceCatalogFieldsCard,
  incidentIoCard,
  teamManagerCard,
];
